import { useFeatureFlagVariantKey } from 'posthog-js/react';

import { AUTO_LESSON_ANALYSIS_FEATURE_FLAG } from '../constants/autoAnalysis';
import { isAiBuddy } from '../helper';

/**
 * Gates every Tutopiya AI auto lesson analysis control — the course-page
 * switch and both checkout switches. `test` shows them, `control` (and an
 * unresolved flag) hides them everywhere, and the checkout payloads drop the
 * `autoAnalysis` field entirely so a hidden switch can never opt a student in.
 *
 * The AI Buddy tenant never gets the feature, whatever the flag resolves to.
 * No auto analysis event fires for those users either, so they stay out of the
 * experiment's funnels.
 */
export const useAutoLessonAnalysisEnabled = (): boolean => {
  const variant = useFeatureFlagVariantKey(AUTO_LESSON_ANALYSIS_FEATURE_FLAG);

  if (isAiBuddy()) return false;

  return variant === 'test';
};

export default useAutoLessonAnalysisEnabled;
